
    import { Component, Mixins } from 'vue-property-decorator';
    import ProductCard from '@rogues/ProductCard/shared/productCard';

    @Component
    /**
     * @name Simple
     */
    export default class Simple extends Mixins(ProductCard) {
        responsive = {
            image: {
                768: '142px',
            },
            icon_button: {
                768: 'plus',
            },
        }
    }
